/* Flower Guy occasion reminders
   Captures up to 5 occasions (name + occasion + day/month) and saves them two ways:
   1. Omnisend contact custom properties, so the reminder emails can say
      "Sarah's birthday is coming up" and a daily job can find whose date is near.
   2. Shopify customer tags in a short, 40-character-safe code, e.g. rem:03-12:B:Sarah
      so the same data is readable from Shopify without Omnisend.
   The Shopify customer form still creates the customer and the occasion-reminders tag.
*/
(function () {
  if (window.__fgRemInit) { return; }
  window.__fgRemInit = true;

  var MAX = 5;
  var MONTHS = { January: '01', February: '02', March: '03', April: '04', May: '05', June: '06', July: '07', August: '08', September: '09', October: '10', November: '11', December: '12' };
  var OCC_CODE = { 'Birthday': 'B', 'Anniversary': 'A', 'Something else': 'O' };

  function pad(n) { n = String(n); return n.length < 2 ? '0' + n : n; }
  function mmdd(r) { return (MONTHS[r.month] || '00') + '-' + pad(r.day); }
  function code(r) { return OCC_CODE[r.occ] || 'O'; }

  /* Shopify caps each customer tag at 40 characters, so the name is truncated to fit. */
  function safeTag(r) {
    var base = 'rem:' + mmdd(r) + ':' + code(r) + ':';
    return base + String(r.name).substring(0, 40 - base.length);
  }

  function omnisendPayload(email, reminders) {
    var props = { reminder_count: reminders.length, reminder_source: 'flowerguy_club_modal' };
    reminders.forEach(function (r, i) {
      var n = i + 1;
      props['reminder_' + n + '_name'] = r.name;
      props['reminder_' + n + '_occasion'] = r.occ;
      props['reminder_' + n + '_date'] = mmdd(r);
      props['reminder_' + n + '_label'] = r.day + ' ' + r.month;
    });
    return { email: email, tags: ['occasion-reminders'], customProperties: props };
  }

  function pushOmnisend(payload) {
    try {
      if (!payload || !payload.email) { return; }
      window.omnisend = window.omnisend || [];
      window.omnisend.push(['identifyContact', payload]);
    } catch (e) {}
  }

  function ready(fn) {
    if (document.readyState != 'loading') { fn(); } else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    var overlay = document.getElementById('fg-rem-overlay');
    var reminders = [], occ = '';

    function badge() {
      var count = 0;
      try { var s = JSON.parse(localStorage.getItem('fg-reminders') || 'null'); if (s && s.count) { count = s.count; } } catch (e) {}
      document.querySelectorAll('[data-fg-rem-badge]').forEach(function (b) {
        if (count > 0) { b.textContent = count; b.hidden = false; } else { b.hidden = true; }
      });
    }
    badge();

    function openRem() { if (overlay) { overlay.classList.add('open'); document.body.style.overflow = 'hidden'; } }
    function closeRem() { if (overlay) { overlay.classList.remove('open'); document.body.style.overflow = ''; } }

    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-fg-rem-open]') : null;
      if (t) { e.preventDefault(); openRem(); return; }
      var c = e.target && e.target.closest ? e.target.closest('[data-fg-rem-close]') : null;
      if (c) { e.preventDefault(); closeRem(); return; }
    }, false);
    if (overlay) { overlay.addEventListener('click', function (e) { if (e.target === overlay) { closeRem(); } }); }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeRem(); } });

    var daySel = document.getElementById('fg-rem-day');
    if (daySel) { for (var d = 1; d <= 31; d++) { var o = document.createElement('option'); o.textContent = d; daySel.appendChild(o); } }

    var occWrap = document.getElementById('fg-rem-occ');
    if (occWrap) {
      Array.prototype.forEach.call(occWrap.querySelectorAll('button'), function (b) {
        b.addEventListener('click', function () {
          Array.prototype.forEach.call(occWrap.querySelectorAll('button'), function (x) { x.classList.remove('on'); });
          b.classList.add('on'); occ = b.getAttribute('data-occ');
        });
      });
    }

    function render() {
      var list = document.getElementById('fg-rem-list'); if (!list) return;
      list.innerHTML = '';
      reminders.forEach(function (r, i) {
        var li = document.createElement('li'), span = document.createElement('span');
        span.textContent = r.occ + ' · ' + r.name + ' · ' + r.day + ' ' + r.month;
        var rm = document.createElement('button'); rm.type = 'button'; rm.textContent = 'Remove';
        rm.addEventListener('click', function () { reminders.splice(i, 1); render(); });
        li.appendChild(span); li.appendChild(rm); list.appendChild(li);
      });
      document.getElementById('fg-rem-n').textContent = reminders.length;
      document.getElementById('fg-rem-save').disabled = reminders.length < 1;
      var tags = ['occasion-reminders'];
      reminders.forEach(function (r) { tags.push(safeTag(r)); });
      document.getElementById('fg-rem-tags').value = tags.join(',');
    }

    var addBtn = document.getElementById('fg-rem-add');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var name = document.getElementById('fg-rem-name').value.replace(/[|,:]/g, ' ').trim();
        var day = daySel.value, month = document.getElementById('fg-rem-month').value;
        if (!name || !occ || !day || !month) { alert('Please add their name, the occasion, and the date.'); return; }
        if (reminders.length >= MAX) { alert('Five reminders is the maximum for now.'); return; }
        reminders.push({ name: name, occ: occ, day: day, month: month });
        document.getElementById('fg-rem-name').value = ''; daySel.value = ''; document.getElementById('fg-rem-month').value = '';
        Array.prototype.forEach.call(occWrap.querySelectorAll('button'), function (x) { x.classList.remove('on'); }); occ = '';
        render();
      });
    }

    /* On submit: send to Omnisend first, hold the page briefly so the push lands,
       then let the Shopify customer form post as normal. */
    var cform = document.getElementById('fg-rem-customer-form');
    var submitting = false;
    if (cform) {
      cform.addEventListener('submit', function (e) {
        if (submitting) { return; }
        var email = (document.getElementById('fg-rem-email') || {}).value || '';
        if (!email || reminders.length < 1) { return; }
        e.preventDefault();
        submitting = true;
        var payload = omnisendPayload(email, reminders);
        pushOmnisend(payload);
        try {
          sessionStorage.setItem('fg-rem-sent', '1');
          sessionStorage.setItem('fg-rem-pending', JSON.stringify({ count: reminders.length, reminders: reminders }));
          sessionStorage.setItem('fg-rem-omnisend', JSON.stringify(payload));
        } catch (err) {}
        var btn = document.getElementById('fg-rem-save');
        if (btn) { btn.disabled = true; btn.textContent = 'Saving...'; }
        setTimeout(function () { cform.submit(); }, 700);
      });
    }

    var sent = false;
    try { sent = sessionStorage.getItem('fg-rem-sent') === '1'; } catch (e) {}
    if (sent && (window.location.search.indexOf('customer_posted=true') !== -1 || window.location.hash.indexOf('contact_form') !== -1)) {
      try {
        sessionStorage.removeItem('fg-rem-sent');
        /* Re-push after the redirect in case the first push did not flush before navigation. */
        var again = sessionStorage.getItem('fg-rem-omnisend');
        if (again) { pushOmnisend(JSON.parse(again)); sessionStorage.removeItem('fg-rem-omnisend'); }
        var pending = sessionStorage.getItem('fg-rem-pending');
        if (pending) { localStorage.setItem('fg-reminders', pending); sessionStorage.removeItem('fg-rem-pending'); }
      } catch (e) {}
      badge();
      var f = document.getElementById('fg-rem-form'); if (f) f.style.display = 'none';
      var dn = document.getElementById('fg-rem-done'); if (dn) dn.style.display = 'block';
      openRem();
    }

    try { if (/[?&]reminders=open/.test(window.location.search)) { openRem(); } } catch (e) {}
  });
})();
